module.exports = __webpack_public_path__ + "media/images/menu/crater-e88c51232cfa9fe6e8fafb04890ec913.jpg";